<template>
  <generic-modal
    :title="$t('endpoint')"
    icon="project diagram"
    image="/images/icons/api_manager.png"
    v-on:destroy="destroy"
    :scrolling="true"
    v-bind:on_finished="this.finished"
    :footer_buttons="footer_buttons"
  >
    <div class="description">
      <div class="ui three item pointing secondary menu" ref="tabs">
        <a class="active item" data-tab="general_info">
          <i class="info circle icon"></i>
          {{ $t("general info") }}
        </a>
        <a class="item" data-tab="security">
          <i class="shield icon"></i>
          {{ $t("security") }}
        </a>
        <a class="item" data-tab="testing">
          <i class="lightning icon"></i>
          {{ $t("test") }}
        </a>
        <!-- <a class="item" data-tab="code">
          <i class="code icon"></i>
          {{ $t("code") }}
        </a> -->
      </div>
      <div
        class="ui bottom attached active tab segment"
        data-tab="general_info"
      >
        <general
          :endpoint_in="endpoint_in"
          ref="general"
          :projects="projects"
        />
      </div>
      <div class="ui bottom attached tab segment" data-tab="security">
        <security :endpoint_in="endpoint_in" ref="security" />
      </div>
      <div class="ui bottom attached tab segment" data-tab="testing">
        <testing :endpoint_in="endpoint_in" ref="testing" />
      </div>
      <!-- <div class="ui bottom attached tab segment" data-tab="code">
        <api-code :endpoint_in="endpoint_in" ref="code" />
      </div> -->
    </div>
  </generic-modal>
</template>

<script>
import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import General from "./General";
import Security from "./Security";
import Testing from "./Testing";
import { setTimeout } from "timers";
// import ApiCode from "./Code";

export default {
  name: "APIManagerEndpointModal",
  components: {
    "generic-modal": GenericModal,
    General,
    Security,
    Testing,
    // ApiCode,
  },
  props: {
    endpoint_in: Object,
    projects: Array,
  },
  computed: {},
  data() {
    return {
      footer_buttons: [
        {
          icon: "trash",
          color: "red",
          text: this.$t("delete"),
          click: this.remove,
          visibility_condition: this.endpoint_in ? true : false,
        },
      ],
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function (resolve, reject) {
        // console.log("XXS");
        let isValid = vm.$refs.general.isValid() && vm.$refs.security.isValid();

        if (!isValid) reject();
        else {
          local_api(vm, "post", "/api_manager/do-save-endpoint", {
            i: vm.endpoint_in ? vm.endpoint_in.uuid : null,
            n: vm.$refs.general.getData().name,
            u: vm.$refs.general.getData().url,
            s: {
              general: vm.$refs.general.getData(),
              security: vm.$refs.security.getData(),
            },
          })
            .then((endpoint) => {
              endpoint.setup = JSON.parse(endpoint.setup);
              vm.$emit("succedded", endpoint);
              resolve();
            })
            .catch((err) => {
              window.jQuery(vm.$refs.form).form("add errors", [err]);
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    remove() {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove endpoint?"),
        function () {
          local_api(vm, "post", "/api_manager/do-remove-endpoint", {
            u: vm.endpoint_in.uuid,
          })
            .then(() => {
              vm.$emit("deleted", vm.endpoint_in);
              window.jQuery(vm.$el).modal("hide");
            })
            .catch((err) => {
              vm.$alertify.error(stringify(err));
            });
        },
      );
    },
  },
  mounted() {
    let vm = this;

    setTimeout(() => {
      window.jQuery(vm.$refs.tabs).find(".item").tab();
    }, 1000);
  },
  watch: {},
  updated: function () {},
};
</script>
